import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TVesselInfo, TVesselVoyageDailySignalsSliceState, VESSEL_VOYAGE_DAILY_SIGNALS } from '../mapTypes';

const initialState: TVesselVoyageDailySignalsSliceState = {
    vesselVoyageDailySignalsData: null,
    vesselVoyageDailySignalsLoading: false,
    vesselVoyageDailySignalsError: null,
};

const vesselVoyageDailySignalsSlice = createSlice({
    name: VESSEL_VOYAGE_DAILY_SIGNALS,
    initialState,
    reducers: {
        emptyVesselVoyageDailySignalsAction: (state: TVesselVoyageDailySignalsSliceState) => {
            state.vesselVoyageDailySignalsData = null;
            state.vesselVoyageDailySignalsLoading = false;
            state.vesselVoyageDailySignalsError = null;
        },
        getVesselVoyageDailySignalsRequestAction: (state: TVesselVoyageDailySignalsSliceState, _: PayloadAction<{ imoNumbers: number[], startDate: string, endDate: string }>) => {
            state.vesselVoyageDailySignalsLoading = true;
            state.vesselVoyageDailySignalsError = null;
        },
        getVesselVoyageDailySignalsSuccessAction: (
            state: TVesselVoyageDailySignalsSliceState,
            { payload: data }: PayloadAction<TVesselInfo>,
        ) => {
            state.vesselVoyageDailySignalsLoading = false;
            state.vesselVoyageDailySignalsData = data;
            state.vesselVoyageDailySignalsError = null;
        },
        getVesselVoyageDailySignalsErrorAction: (
            state: TVesselVoyageDailySignalsSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.vesselVoyageDailySignalsData = null;
            state.vesselVoyageDailySignalsLoading = false;
            state.vesselVoyageDailySignalsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const {
    emptyVesselVoyageDailySignalsAction,
    getVesselVoyageDailySignalsRequestAction,
    getVesselVoyageDailySignalsSuccessAction,
    getVesselVoyageDailySignalsErrorAction
} =
    vesselVoyageDailySignalsSlice.actions;
export default vesselVoyageDailySignalsSlice.reducer;
